export default {
    getAllConfigrations (state) {
        return state.allConfigurations
    },
    getFreePreviewStatus (state) {
        return state.isFreePreviewEnabled
    },
    getLiveStreamingStatus (state) {
        return state.enableLiveStreaming
    },
    getMessageDuration (state) {
        return state.messageDuration
    },
    getLiveStreamingURL (state) {
        return state.liveStreamingURL
    },
    getCorpStreamingURL (state) {
        return state.CorpLiveStreamingURL
    },
    getAlertMsgStatus (state) {
        return state.showHeaderAlert
    },
    getTrialDays (state) {
        return state.daysLeft
        // return -1
    },
    getCardExpiryDays (state) {
        return state.cardExpiryDays
    },
    getTotalTrialDays (state) {
        return state.totalTrialDays
    },
    getPressReleaseData (state) {
        return state.pressReleaseData
    },
    getMessageBoard (state) {
        return state.messageBoard
    },
    getAllArticles (state) {
        return state.allArticles
    },
    getSelectedArticle (state) {
        return state.selectedArticle
    },
    getEventSwitchTime (state) {
        return state.defEventSwitch
    },
    getCorporateLiveStreamFlag (state) {
        return state.enableCorporateLiveStreaming
    },
    getFAQs (state) {
        return state.faqs
    },
    getMembers (state) {
        return state.members
    },
    getSiteStatus (state) {
        return state.isMaintenance
    },
    getGiftingText (state) {
        return state.giftingText
    },
    getCustomUnauthBannerStatus (state) {
        return state.showCustomUnauthBanner
    },
    getCustomUnauthBannerText (state) {
        return state.unauthBannerText
    },
    getCustomUnauthBannerLink (state) {
        return state.unauthBannerLink
    },
    getGiftingLinksFlag (state) {
        return state.turnOffGifting
    },
    getPaidMembershipFlag (state) {
        return state.paidMembershipService
    },
    getProfileCharitySection (state) {
        return state.profileCharitySection
    },
    getAuthLeftTopBannerMessage (state) {
        return state.authLeftTopBannerMessage
    },
    getAuthLeftTopBannerUrl (state) {
        return state.authLeftTopBannerUrl
    },
    getFindOutMoreUrl (state) {
        return state.unauthFindMoreUrl
    },
    getShowCountFlag (state) {
        return state.showEventParticipantCount
    },
    getAdvisoryBoard (state) {
        return state.advisoryBoard
    },
    getRequestDecodedData (state) {
        return state.requestDecodedData
    }
}



// WEBPACK FOOTER //
// ./src/store/configuration/getters.js